import { Module } from '@nestjs/common';
import { SoakingSampleTestController } from './soaking-sample-test.controller';
import { SoakingSampleTestService } from './soaking-sample-test.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { SoakingSampleTest } from '../entities/soaking-sample-test.entity';
import { SoakingSampleTestAdapter } from '../dto/soaking-sample-test-adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
@Module({

  imports: [
    TypeOrmModule.forFeature([
      SoakingSampleTest
    ]),
  ],
  controllers: [SoakingSampleTestController],
  providers: [SoakingSampleTestService, SoakingSampleTestAdapter, ApplicationExceptionHandler]
})
export class SoakingSampleTestModule { }
